import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Alert,
    CircularProgress,
    Button,
    Paper,
    Dialog,
    IconButton,
    LinearProgress,
} from "@mui/material";
import { Cancel, Delete, Remove } from "@mui/icons-material";
import { useCookies } from "react-cookie";

const KASSE_ENDPOINT = "https://fkcrenezvf.execute-api.eu-central-1.amazonaws.com/Prod";


export default function OpenTransactionStatus({ clientId, onLoad, onAbort }) {
    const [openTransactions, setOpenTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [cookies] = useCookies(["crKey"]);


    const authHeaders = {
        headers: {
            Authorization: `Bearer ${cookies.crKey} y 1 z`,
        },
    };


    const fetchStatus = async () => {
        setLoading(true);
        setError(null);
        try {
            const url = clientId
                ? `${KASSE_ENDPOINT}/status?client_id=${clientId}`
                : `${KASSE_ENDPOINT}/status`;
            const { data } = await axios.get(url, authHeaders);
            setOpenTransactions(data.open_transactions || []);
        } catch (err) {
            setError("Fehler beim Laden der Statusinformationen.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStatus();
    }, [clientId]);

    const [open, setOpen] = useState(false);

    if (loading) return <LinearProgress />;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (openTransactions.length === 0) return null;

    return (
        <Box>
            <Paper sx={{ backgroundColor: 'red', p: 2, }}>
                <Typography color={"white"} fontWeight={"bold"}>Es gibt offene Kassenvorgänge!</Typography>
                <Button onClick={() => setOpen(!open)} variant="outlined" sx={{ color: 'white', borderColor: 'white' }}>{open ? 'Verbergen' : 'Anzeigen'}</Button>
            </Paper>
            <Dialog open={open}>
                <Paper elevation={3} sx={{ p: 3, backgroundColor: "#fff8e1" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

                        <Typography variant="h6" color="error" gutterBottom>
                            ⚠️ Es gibt offene Kassenvorgänge!
                        </Typography>
                        {open && <IconButton onClick={() => setOpen(!open)} variant="outlined" sx={open ? {} : { color: 'white', borderColor: 'white' }}><Cancel /></IconButton>}
                    </Box>
                    <Typography variant="body1" gutterBottom>
                        Folgende Transaktionen müssen abgeschlossen oder abgebrochen werden:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2 }}>
                        {openTransactions.map((tx) => (
                            <li key={tx.TransactionId}>
                                <Typography variant="body2" className="font-mono">
                                    {tx.TransactionId} ({tx.State})
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 2, py: 1 }}>

                                    {false &&
                                        <Button
                                            variant="outlined"
                                            onClick={() => { setOpen(false); onLoad(tx); }}
                                        >
                                            Laden
                                        </Button>
                                    }
                                    <Button
                                        onClick={() => { onAbort({ transactionId: tx.TransactionId }); }}
                                        startIcon={<Delete />}
                                        variant="outlined"

                                    >
                                        Abbrechen
                                    </Button>
                                </Box>
                            </li>
                        ))}
                    </Box>
                    <Box mt={2}>
                        <Button variant="contained" onClick={fetchStatus}>
                            Erneut prüfen
                        </Button>
                    </Box>
                </Paper>
            </Dialog>
        </Box>
    );
}
